import { useState, useEffect } from "react";
import "./App.css";
import { NewRoom } from "./NewRoom";
import { Tutorial } from "./Pages/Tutorial/Tutorial";
import { Background } from "./Components/Background";
import Menu from "./Pages/Menu";
import StartPage from "./Pages/StartPage";
import CreateRoom from "./Pages/CreateRoom";
import JoinRoom from "./Pages/JoinRoom";

import socketIO from "socket.io-client";

import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";

import { InfoMessage } from "./Components/InfoMessage/InfoMessage";

import useThemeColor from "./hooks/TopBarColorWheel";
import useContainerHeight from "./hooks/useContainerHeight";
import AIRoom from "./AIRoom.tsx";

const socket = socketIO.connect("https://www.fyl.la:4000", {
  transports: ["websocket", "polling", "flashsocket"],
});
// const socket = socketIO.connect("http://192.168.0.231:4000", {
//   transports: ["websocket", "polling", "flashsocket"],
// });

const fetchString = "https://www.fyl.la:4000/api/";
// const fetchString = "http://192.168.0.231:4000/api/";

export function StartScreen() {
  useThemeColor();
  const containerHeight = useContainerHeight();

  const [roomName, setRoomName] = useState(""); // todo this is not needed can use roomInput
  const [roomState, setRoomState] = useState("start screen");
  const [openJoin, setopenJoin] = useState(false);
  const [openCreateState, setOpenCreateState] = useState("");
  const [showAIRoomDoneButtons, setShowAIRoomDoneButtons] = useState(false);

  const [AIRoomState, setAIRoomState] = useState("setup");

  const [cameFromJoin, setCameFromJoin] = useState(false);

  const [openMenu, setopenMenu] = useState(false);
  const [roomInput, setRoomInput] = useState("");

  const [shouldShow, setShouldShow] = useState(false);
  const [color, setColor] = useState("");
  const [text, setText] = useState("");
  const [add, setAdd] = useState(false);

  function showInfoMessage(
    type,
    message,
    isAdd,
    duration = "medium",
    isDelay = false,
  ) {
    const getDurationMs = (duration) => {
      switch (duration) {
        case "short":
          return 2500;
        case "medium":
          return 5000;
        case "long":
          return 20000;
        default:
          return 5000; // fallback to medium
      }
    };

    const durationMs = getDurationMs(duration);

    setAdd(!!isAdd);
    setColor(type === "warning" ? "#FF4D00" : "#F42272");

    const show = () => {
      setText(message);
      setShouldShow(true);
      setTimeout(() => setShouldShow(false), durationMs);
    };

    if (isDelay) {
      setTimeout(show, 2000); // Delay before showing the message
    } else {
      show();
    }
  }

  const [firstTime, setFirstTime] = useState(() => {
    const saved = localStorage.getItem("firstTime");
    return saved || "true";
  });

  const [language, setLanguage] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("language");
    return saved || "norsk";
  });

  const { t, i18n } = useTranslation();

  const [isMenuAnimating, setIsMenuAnimating] = useState(false);

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isRightSwipe) setopenMenu(true);
    if (isLeftSwipe) {
      setIsMenuAnimating(true);
      setTimeout(() => {
        setIsMenuAnimating(false);
        setopenMenu(false);
      }, 500); // Adjust the timeout based on your animation duration
    }
  };

  useEffect(() => {
    localStorage.setItem("language", language);
    i18n.changeLanguage(language);

    localStorage.setItem("firstTime", firstTime);
  }, [language, firstTime]);

  const onInputChange = (e) => {
    const input = e.currentTarget.value;
    if (/^[^!-\/:-@\[-`{-~]+$/.test(input) || input === "") {
      setRoomInput(input);
    }
  };

  const joinRoom = () => {
    if (roomInput !== "") {
      canJoin();
      setRoomName(roomInput);
    }
    document.getElementById("page").scrollIntoView();
  };

  const canJoin = async () => {
    var roomType = await isPresent(roomInput.toLowerCase().trim());
    if (roomType === "classic room") {
      setRoomState("classic room");
      setopenJoin(false);
    } else if (roomType === "ai room setup not done") {
      // todo !! ! ! !  !  !  !
      setAIRoomState("setup");
      setRoomState("ai room");
      setopenJoin(false);
    } else if (roomType === "ai room setup done") {
      // todo !! ! ! !  !  !  !

      setShowAIRoomDoneButtons(true);

      setopenJoin(false);
    } else {
      showInfoMessage("warning", t("no-exist"), false);
    }
  };

  const isPresent = async (roomName) => {
    const isClassicRoom = await fetch(fetchString + "classic/" + roomName, {
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        return JSON.stringify(data) !== "{}";
      });
    if (isClassicRoom) return "classic room";

    const aiRoomInfo = await fetch(fetchString + "ai/" + roomName, {
      headers: {
        Accept: "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (JSON.stringify(data) === "{}") return false;
        else {
          const isDoneSettingUp = data["data"][3];
          if (isDoneSettingUp) return "setup done";
          else return "setup not done";
        }
      });
    if (aiRoomInfo === "setup not done") return "ai room setup not done";
    else if (aiRoomInfo === "setup done") return "ai room setup done";
    return false;
  };

  const idIsFree = async (input) => {
    const present = await isPresent(input);
    return !present;
  };

  const createRoom = async () => {
    if (roomInput !== "") {
      const free = await idIsFree(roomInput.toLowerCase().trim());
      if (free) {
        // socket.emit(
        //   "create " + openCreateState,
        //   roomInput.toLowerCase().trim(),
        // );
        // setRoomName(roomInput.toLowerCase().trim());
        // setRoomState(openCreateState);
        // setOpenCreateState("");

        if (roomInput.toLowerCase().trim().startsWith("ai ")) {
          socket.emit("create ai room", roomInput.toLowerCase().trim());
          setRoomName(roomInput.toLowerCase().trim());
          setRoomState("ai room");
          setAIRoomState("setup");
          setOpenCreateState("");
        } else {
          socket.emit(
            "create " + openCreateState,
            roomInput.toLowerCase().trim(),
          );
          setRoomName(roomInput.toLowerCase().trim());
          setRoomState(openCreateState);
          setOpenCreateState("");
        }
      } else showInfoMessage("warning", t("taken"), false);
    }
    document.getElementById("page").scrollIntoView();
  };

  const openJoinFunc = () => {
    setopenJoin(!openJoin);
  };

  const openCreateFunc = (state) => {
    setOpenCreateState(state);
  };

  const changeLanguage = () => {
    if (language === "norsk") {
      setLanguage("english");
      i18n.changeLanguage("english");
    } else {
      setLanguage("norsk");
      i18n.changeLanguage("norsk");
    }
  };

  const closeMenu = () => {
    setIsMenuAnimating(true);
    setTimeout(() => {
      setIsMenuAnimating(false);
      setopenMenu(false);
    }, 500); // Adjust the timeout based on your animation duration
  };

  const AIRoomDoneButtons = () => {
    return (
      <div className="App-header">
        <div className="container-row-start lift-topbar">
          <div
            className="button-tertiary-m button-text-m text-color-black"
            onClick={() => setShowAIRoomDoneButtons(false)}
            style={{ maxHeight: "32.5px" }}
          >
            {t("back")}
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <div
            className="button-primary black-fill button-text-l text-color-pink shadow-pink box-button-center"
            onClick={() => {
              setRoomState("ai room");
              setAIRoomState("manual entry");
              setShowAIRoomDoneButtons(false);
              setCameFromJoin(true);
            }}
          >
            LEGG TIL SELV
          </div>
          <div
            className="button-primary black-fill button-text-l text-color-pink shadow-pink box-button-center"
            onClick={() => {
              setAIRoomState("done");
              setRoomState("ai room");
              setShowAIRoomDoneButtons(false);
            }}
          >
            START SPILLET
          </div>
        </div>
      </div>
    );
  };

  function renderAppContent() {
    if (roomState === "classic room") {
      return firstTime === "true" ? (
        <Tutorial setFirstTime={setFirstTime} />
      ) : (
        <NewRoom
          socket={socket}
          roomName={roomName.toLowerCase().trim()}
          setRoomState={setRoomState}
          containerHeight={containerHeight}
          showInfoMessage={showInfoMessage}
        />
      );
    } else if (roomState === "ai room") {
      return (
        <AIRoom
          roomName={roomName}
          setRoomState={setRoomState}
          AIRoomState={AIRoomState}
          socket={socket}
          setAIRoomState={setAIRoomState}
          containerHeight={containerHeight}
          showInfoMessage={showInfoMessage}
          cameFromJoin={cameFromJoin}
          setCameFromJoin={setCameFromJoin}
        />
      );
    } else if (showAIRoomDoneButtons) {
      return AIRoomDoneButtons();
    }

    return (
      <>
        {openMenu && (
          <Menu
            isMenuAnimating={isMenuAnimating}
            containerHeight={containerHeight}
            changeLanguage={changeLanguage}
            language={language}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            closeMenu={closeMenu}
            t={t}
          />
        )}

        {openCreateState === "" && !openJoin && (
          <StartPage
            openCreateFunc={openCreateFunc}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            setopenMenu={setopenMenu}
            openJoinFunc={openJoinFunc}
            t={t}
            setAIRoomState={setAIRoomState}
          />
        )}

        {openCreateState !== "" && (
          <CreateRoom
            openCreateFunc={openCreateFunc}
            roomInput={roomInput}
            onInputChange={onInputChange}
            createRoom={createRoom}
            t={t}
          />
        )}

        {openJoin && (
          <JoinRoom
            openJoinFunc={openJoinFunc}
            roomInput={roomInput}
            onInputChange={onInputChange}
            joinRoom={joinRoom}
            t={t}
          />
        )}
      </>
    );
  }

  return (
    <>
      <InfoMessage
        shouldShow={shouldShow}
        color={color}
        text={text}
        add={add}
        setShouldShow={setShouldShow}
      />

      <div id="page" style={{ touchAction: "none" }}>
        <div className="App" style={{ height: containerHeight - 48 }}>
          {renderAppContent()}
        </div>

        <Background roomState={roomState} containerHeight={containerHeight} />
      </div>
    </>
  );
}
